module.exports = __webpack_public_path__ + "static/media/MileMarkerDinner.ad4283e0.pdf";